let api = {
  getPost(postID) {
    return $.ajax({
      url: baseApiUrl + "post",
      method: "GET",
      data: {
        id: postID
      }
    }).done(function(data) {
      return data;
    }).fail(function(data) {
      return data;
    });
  },

  getPosts(sort, perPage, page) {
    return $.ajax({
      url: baseApiUrl + "posts_html",
      method: "GET",
      data: {
        sort: sort,
        per_page: perPage,
        page: page
      }
    }).done(function(data) {
      return data;
    }).fail(function(data) {
      return data;
    });
  },

  getShareLinks(postID) {
    return $.ajax({
      url: baseApiUrl + "social_links",
      method: "GET",
      data: {
        post_id: postID
      }
    }).done(function(data) {
      return data;
    }).fail(function(data) {
      return data;
    });
  },

  like(postID, vote) {
    return $.ajax({
      url: baseApiUrl + "like",
      method: "POST",

      beforeSend: function (xhr) {
        xhr.setRequestHeader('X-WP-Nonce', apiUserNonce);
      },
      data: {
        post: postID,
        vote: vote
      }
    }).done(function(data) {
      return data;
    }).fail(function(data) {
      return data;
    });
  }
};

export default api;



// WEBPACK FOOTER //
// ./static/js/components/ApiHelper.js